import { render, staticRenderFns } from "./ImaginaryUpgradeButton.vue?vue&type=template&id=a6a4fd36&scoped=true&"
import script from "./ImaginaryUpgradeButton.vue?vue&type=script&lang=js&"
export * from "./ImaginaryUpgradeButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6a4fd36",
  null
  
)

export default component.exports